import { useLocalStorageValue } from '@lumahealthhq/ui-utils';
import sanitizeToken from '../utils/sanitizeToken';
import useKeyAuthToken from './useKeyAuthToken';
export default function useCurrentToken() {
  const keyAuthToken = useKeyAuthToken();
  const [token, setToken] = useLocalStorageValue(keyAuthToken);
  return [sanitizeToken(token) || null, setToken];
}